import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    // Initialize fbq function
    const fbq = function (...args: any[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    } as any;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [] as any[];
    window.fbq = fbq;
    window._fbq = fbq;
    // Load the Facebook Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize pixel
    window.fbq('init', '1272995411715259');
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-57">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1272995411715259&ev=PageView&noscript=1" data-id="element-58" />
    </noscript>;
}
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}